import { resolveReadableObjectNamesLower } from './permissionCache';

const TASK_RELATED_OBJECT_DENYLIST = new Set([
  'email_log',
  'attachment',
  'recordview',
  'document_template',
  'email_template',
  'role',
  'password_reset',
  'user_device',
]);

/**
 * Objects that must not appear as task "Related Object" (layout + runtime pickers).
 * Excludes system / child / package objects and anything the org should not relate tasks to.
 */
export function isExcludedFromTaskRelatedObjectPicker(objectConfigRow) {
  const raw = objectConfigRow && objectConfigRow.object_name;
  const name = String(raw || '').trim();
  if (!name) return true;
  const lower = name.toLowerCase();

  if (TASK_RELATED_OBJECT_DENYLIST.has(lower)) return true;
  if (objectConfigRow.is_history_object === true) return true;
  if (lower.endsWith('_history')) return true;

  if (lower === 'watconnect' || lower.startsWith('watconnect_')) return true;
  if (lower.startsWith('email_campaign')) return true;
  if (lower.startsWith('telecmi_')) return true;

  return false;
}

/**
 * @returns {Promise<Set<string>|null>} `null` if admin (no object-level filter); otherwise lowercase
 *   object API names the role may read (view) — same rule as list/detail access.
 */
export async function resolveReadableObjectNamesLowerForTaskRelatedPicker() {
  return resolveReadableObjectNamesLower();
}
